import { render, staticRenderFns } from "./techConsultManager.vue?vue&type=template&id=3a5d9fe4"
import script from "./techConsultManager.vue?vue&type=script&lang=js"
export * from "./techConsultManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports